import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import Auth from './pages/Auth';
import Sidebar from './components/Sidebar';
import BuyNow from './pages/BuyNow';
import StockStatus from './pages/StockStatus';
import MyOrders from './pages/MyOrders';
import Wallet from './pages/Wallet';
import Profile from './pages/Profile';
import Feedback from './pages/Feedback';
import Support from './pages/Support';
import DepositModal from './components/DepositModal';
import { Toaster } from './components/ui/toaster';
import AdminApp from './pages/admin/AdminApp';

const Shell = () => {
  const { user, authLoading } = useApp();
  const [page, setPage] = useState('buy');
  const [depositOpen, setDepositOpen] = useState(false);

  if (authLoading) {
    return <div className="min-h-screen w-full flex items-center justify-center bg-[#050505] text-[#7a7a7a] font-mono text-sm">Connecting to store…</div>;
  }
  if (!user) return <Auth />;

  const openDeposit = () => setDepositOpen(true);

  const renderPage = () => {
    switch (page) {
      case 'buy': return <BuyNow onDeposit={openDeposit} />;
      case 'stock': return <StockStatus onDeposit={openDeposit} />;
      case 'orders': return <MyOrders onDeposit={openDeposit} />;
      case 'wallet': return <Wallet onDeposit={openDeposit} />;
      case 'profile': return <Profile onDeposit={openDeposit} />;
      case 'feedback': return <Feedback onDeposit={openDeposit} />;
      case 'support': return <Support onDeposit={openDeposit} />;
      default: return <BuyNow onDeposit={openDeposit} />;
    }
  };

  return (
    <div className="min-h-screen w-full bg-[#050505] text-[#e6e6e6] flex">
      <Sidebar page={page} setPage={setPage} />
      <main className="flex-1 min-w-0">
        {renderPage()}
      </main>
      <DepositModal open={depositOpen} onClose={() => setDepositOpen(false)} />
    </div>
  );
};

const StoreApp = () => (
  <AppProvider>
    <Shell />
    <Toaster />
  </AppProvider>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="/*" element={<StoreApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
